import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaProgressCircleComponent from './VaProgressCircle.vue'

export const VaProgressCircle = withConfigTransport(VaProgressCircleComponent)
